// extracted by mini-css-extract-plugin
export default {"chip":"IconChip-module__chip--_W4mY","selected":"IconChip-module__selected--Dcu81","icon":"IconChip-module__icon--HbjO3"};